import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setLoginSession } from '../../utils/auth'; // Importing the helper logic
import axios from "axios";
import { APIURL } from '../../utils/Variables';
import { useExternalData } from '../../utils/ApiContext';

function Login() {
    const [username, setUsername] = useState('uber');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('')
    const navigate = useNavigate();
    const { loginSuccess } = useExternalData();
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password == "Uber@2026") {
            try {
                const API = axios.create();
                const data = {
                    username : username,
                    password : password
                }
                const response = await API.post(APIURL + "/login", data);
                console.log("response",response.data)
                localStorage.setItem("refresh_token", response.data.refreshToken);
                localStorage.setItem("loginTime", Date.now());
                setLoginSession({ username });
                loginSuccess(response.data.accessToken);
                navigate('/');
                setError('')
            } catch (error) {
                setError("Invalid Username or Password");
            }
        } else {
            setError("Invalid Password");
        }
    };


    return (
        <div className='login-container'>
            <div className='login-card-main'>
                <img src='/uploads/Brand/uber_white.webp' style={{ width: '70%', margin: 'auto', padding: '20px' }} />
                <div className='' >
                    <form onSubmit={handleSubmit} className='form'>
                        {/* <div className='input-group'>
                        <label>Username</label>
                        <input
                            type="text"
                            className='form-control'
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter username"
                            required
                        />
                    </div> */}
                        <div className='input-group'>
                            <label>Password</label>
                            <input
                                className='form-control'
                                type="password"
                                value={password}
                                onChange={(e) => { setPassword(e.target.value); setError('') }}
                                placeholder="Enter password"
                                required
                            />
                            {error ? <p className='error-text-login'>{error}</p> : <></>}
                        </div>
                        <button type="submit" className='login-btn'>Login</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;